import { memo, ReactElement } from "react";
import cn from "classnames";
import CheckMark from "../../Icons/CheckMark";
import PaperAirplane from "../../Icons/PaperAirplane";
import { getScreenByStep, impressionBase } from "../constants";
import styles from "./ThankYou.module.scss";

interface Props {
    enabled: boolean;
    companyName: string;
}

/**
 * Renders a thankyou screen.
 *
 * @returns {ReactElement} The thankyou screen.
 */
const ThankYou = memo((props: Props): ReactElement => {
    const { companyName, enabled = false } = props;
    const screen = getScreenByStep(5);
    const impression = {
        ...impressionBase,
        sp_modal_screen_name: screen.name,
        sp_modal_screen_order: screen.step,
    };

    return (
        <div
            className={cn(styles.thankYou, enabled ? styles.enabled : "")}
            data-tracking-props={JSON.stringify(impression)}
            data-tracking-event-type="impression"
        >
            <p className={styles.screenHeading}>What happens next:</p>
            <div className={styles.infoBullets}>
                <div className={styles.split}>
                    <p className={styles.steps}>
                        <CheckMark />
                        <span>{`The hiring manager at ${companyName} will review your application.`}</span>
                    </p>
                    <p className={styles.steps}>
                        <CheckMark />
                        <span>You will hear back from the hiring manager as soon as possible.</span>
                    </p>
                </div>
                <PaperAirplane className={styles.paperPlane} />
            </div>
        </div>
    );
});

ThankYou.displayName = "ThankYou";
export default ThankYou;
